import React from 'react';
import { fmtDate } from './lib/format';

/**
 * Snapshot picker, populated ONLY from `fn_get_search_console_dates.snapshot_dates`.
 *
 * A generic date-range picker is explicitly not wanted (§5.2): every panel's window is
 * fixed at 90 days ending three days before the as-of date, and the sentences and panel
 * order are the ones the nightly job generated on that date — not recalculated. Offering
 * an arbitrary date would imply a recalculation that does not happen.
 *
 * Renders nothing when there is only one snapshot (or none) — a select with a single
 * option is a control that cannot do anything.
 */
const AsOfPicker = ({ snapshotDates, value, onChange }) => {
  if (!Array.isArray(snapshotDates) || snapshotDates.length < 2) return null;

  return (
    <div className="flex items-center gap-2">
      <label
        htmlFor="gsc-as-of"
        className="text-xs font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400"
      >
        As of
      </label>
      <select
        id="gsc-as-of"
        value={value || ''}
        onChange={(e) => onChange(e.target.value || null)}
        className="text-sm border border-gray-200 dark:border-gray-700 rounded-lg px-2 py-1 bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300"
      >
        <option value="">Latest</option>
        {snapshotDates.map((d) => (
          <option key={d} value={d}>{fmtDate(d)}</option>
        ))}
      </select>
    </div>
  );
};

export default AsOfPicker;
